<template>
  <div class="userPullDown">
    <el-dropdown @command="handleCommand">
      <span class="el-dropdown-link">
        <slot></slot>
      </span>
      <el-dropdown-menu slot="dropdown">
        <!--        <el-dropdown-item command="userInfo" icon="el-icon-user">个人信息</el-dropdown-item>-->
        <!-- <el-dropdown-item command="updatePass" icon="el-icon-edit">修改密码</el-dropdown-item> -->
        <el-dropdown-item   icon="el-icon-warning-outline">版本号:{{ version }}</el-dropdown-item>
        <el-dropdown-item command="logout" icon="el-icon-switch-button">退出登录</el-dropdown-item>
        
      </el-dropdown-menu>
    </el-dropdown>
    <updatePassword ref="updatePassword"></updatePassword>
  </div>
</template>

<script>
import * as u from "@/utils/util";
import * as c from "@/utils/config";
import { MessageBox } from 'element-ui';

export default {
  name: "loginElement",
  components: {
    'updatePassword': () => import('@/components/user/updatePassword.vue'),
  },
  data() {
    return {
      //用户信息
      userInfo: u.getSession(c.sessionKey.USER_INFO),
      version: process.env.VUE_APP_VERSION
    }
  },
  created() {

  },
  methods: {
    //下拉菜单触发时间
    handleCommand(command) {
      switch (command) {
        case 'updatePass':
          this.$refs.updatePassword.openDia();
          break
        case 'userInfo':
          break
        case 'logout':
          MessageBox.confirm('是否确认退出登录?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            console.log('用户确认退出登录');
            // 创建一个 Promise 来等待记录结束时间完成
            return new Promise((resolve) => {
              console.log('发送 before-logout 事件');
              // 通知所有组件记录结束时间，并传递回调函数
              this.$root.$emit('before-logout', resolve);

              // 设置超时保护，最多等待 2 秒
              setTimeout(() => {
                console.log('超时保护触发，强制 resolve');
                resolve();
              }, 2000);
            });
          }).then(() => {
            console.log('记录结束时间完成，开始执行退出登录');
            // 记录结束时间完成后，执行退出登录
            this.$HttpService.post("/sys-login/logout").then(res => {
              this.$util.clearSession();
              // 清除登录状态
              this.$store.commit('SET_LOGIN_STATE', false);
              //清空顶部导航
              this.$store.dispatch("closeAll")
              this.$router.push('/login')
            })
          }).catch(() => {
            // 用户取消退出登录
            console.log('用户取消退出登录');
          })
          break
      }
    },
  }
}
</script>


<style scoped lang="scss">
.userPullDown {}
</style>